// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Divider,
//   FormFieldSet,
//   showToast,
//   useFormHandler,
// } from "../../../../../../../../components";
// import { ExpensesAmountoptions } from "../../../../../../../../assets/data/projectData";
// import { v4 as uuidv4 } from "uuid";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   addOtherPaymentsStart,
//   getAllEmpOtherPayments,
//   setCurrentPayrollEditing,
//   updateOtherPaymentsStart,
// } from "../../../../../../../../redux/slices/payroll/payrollSlice";
// import { filterEmptyValues } from "../../../../../../../../utils/filterEmptyValues";
// import { uploadStart } from "../../../../../../../../redux/slices/universal/fileUploadSlice";
// import { useLoginUser } from "../../../../../../../../hooks/useLoginUser";
// import common from "../../../../../../../../utils/common";
// import axiosRequest from "../../../../../../../../redux/slices/universal/axiosService";
// import { ENDPOINTS } from "../../../../../../../../redux/apiConfig";
// const OtherPayment = ({ rowData }) => {
//   console.log("rowData", rowData);
//   const { getExpenseArray,calculateAmountInForeignCurrency } = common;
//   const dispatch = useDispatch();
//   const { currentPayrollEditing, empDeduction, empOtherPayments } = useSelector(
//     (state) => state.payRoll
//   );
//   const { userData: loginUserData } = useLoginUser();
//   // const organizationId = loginUserData?.organizationId.uiid;
//   const loginUserUiid = loginUserData?.uiid;
//   const employeeId = currentPayrollEditing?.employeeId?.uiid;
//   const [expenseSections, setExpenseSections] = useState([]);
//   const otherPayments = empOtherPayments?.data || [];
//   const latestOne = otherPayments[otherPayments.length - 1];
//   const { formData, errors, handleChange, validateAllFields } = useFormHandler({
//     typeofAmount: "",
//     otherAmount: "",
//     receivedDate: "",
//     exchangeRate: "",
//     attachment: [],
//     totalAmount: "",
//     payrollAmount: "",
//     employersCharges: "",
//     comments: "",
//   });

//   const handleAddClick = () => {
//     if (expenseSections.length < 5) {
//       setExpenseSections([...expenseSections, { id: uuidv4() }]);
//     }
//   };

//   const handleRemoveClick = (index) => {
//     const updated = [...expenseSections];
//     updated.splice(index, 1);
//     setExpenseSections(updated);
//   };
//   const isUpdate = !!currentPayrollEditing?.otherPayments?.uiid;
//   const handleFinalDispatch = (finalSubmissionData) => {
//     const actionType = isUpdate
//       ? updateOtherPaymentsStart
//       : addOtherPaymentsStart;
//     const payload = isUpdate
//       ? [{ type: "SET", value: finalSubmissionData }]
//       : finalSubmissionData;
//     dispatch(
//       actionType({
//         coll: "EmpOtherPay",
//         payload,
//         uiid: currentPayrollEditing?.otherPayments?.uiid,
//         onSuccess: (response) => {
//           const uiid =
//             response?.data?.data?.uiid || response?.data?.data?.doc?.uiid;
//           handleFetchAPICall(uiid);
//         },
//       })
//     );
//   };
//   const handleSubmit = () => {
//     const isValid = validateAllFields();
//     if (isValid) {
//       const total = Number(formData.totalAmount);
//   const payroll = Number(formData.payrollAmount);

//   if (payroll === total) {
//     showToast("Payroll Amount cannot be equal to Total Amount");
//     return;
//   }
//       const morePay = getExpenseArray(expenseSections, formData);
//       const action = {
//         ...(currentPayrollEditing?.otherPayments?.uiid
//           ? {}
//           : { employeeId: employeeId }),
//         amounts: {
//           total: formData?.totalAmount,
//           payroll: formData?.payrollAmount,
//           other: formData?.otherAmount,
//         },
//         payDate: formData?.receivedDate,
//         exchange: {
//           rate: formData?.exchangeRate,
//         },
//         empCharges: formData?.employersCharges,
//         comments: formData?.comments,
//         ...(currentPayrollEditing?.otherPayments?.uiid
//           ? {}
//           : { addedBy: loginUserUiid }),
//         mode: 1,
//         cycle: currentPayrollEditing?.payCycle,
//         morePay: morePay,
//       };
//       const submissionData = filterEmptyValues(action);
//       const cleanAttachments =
//         Array.isArray(formData.attachment) && formData.attachment.length > 0
//           ? formData.attachment
//           : [];

//       if (cleanAttachments.length > 0) {
//         dispatch(
//           uploadStart({
//             uploadType: "multiple",
//             field: "doc",
//             uiid: employeeId,
//             entity: "empotherpays",
//             category: "empotherpays",
//             coll: "EmpOtherPay",
//             doc: cleanAttachments,
//             onSuccess: (fileData) => {
//               const attachmentKeys = fileData
//                 .filter((data) => data.key)
//                 .map((data) => data.key);

//               const updatedSubmissionData = {
//                 ...submissionData,
//                 attachments: attachmentKeys,
//               };

//               handleFinalDispatch(updatedSubmissionData);
//             },
//           })
//         );
//       } else {
//         handleFinalDispatch(submissionData);
//       }
//     } else {
//       showToast("please Fill the all required fields");
//     }
//   };

//   const handleFetchAPICall = async (uiid) => {
//     try {
//       const filter = {
//         uiid: {
//           type: "NONE",
//           value: uiid,
//         },
//       };
//       const response = await axiosRequest({
//         method: "GET",
//         url: ENDPOINTS.EMPLOYEE_OTHER_PAYMENTS.GET_BY_UIID,
//         params: {
//           coll: "EmpOtherPay",
//           fil: JSON.stringify(filter),
//         },
//       });
//       const data = response?.data?.data || {};
//       if (response.success) {
//         // dispatch(setCurrentPayrollEditing({ otherPayments: data }));
//         const oldpayroll =
//           currentPayrollEditing?.otherPayments?.amounts?.payroll || 0;
//         const oldmoreTotal =
//           currentPayrollEditing?.otherPayments?.morePay?.reduce(
//             (acc, item) => acc + (item.amount || 0),
//             0
//           ) || 0;
//         const baseAmount =
//           (currentPayrollEditing?.totalAmount || 0) - oldpayroll - oldmoreTotal;
//         const payroll = data?.amounts?.payroll || 0;
//         const moreTotal =
//           data?.morePay?.reduce((acc, item) => acc + (item.amount || 0), 0) ||
//           0;
//         dispatch(
//           setCurrentPayrollEditing({
//             otherPayments: data,
//             finalOtherTotalAmount: payroll + moreTotal,
//           })
//         );
//         updateFormData(data);
//       }
//     } catch (error) {
//       console.error("Error fetching API:", error);
//     }
//   };
//   const updateFormData = (latestOne) => {
//     handleChange("totalAmount", latestOne?.amounts?.total ?? "");
//     handleChange("payrollAmount", latestOne?.amounts?.payroll ?? "");
//     handleChange("otherAmount", latestOne?.amounts?.other ?? "");
//     handleChange("receivedDate", latestOne?.payDate ?? "");
//     handleChange("exchangeRate", latestOne?.exchange?.rate ?? "");
//     handleChange("employersCharges", latestOne?.empCharges ?? "");
//     handleChange("comments", latestOne?.comments ?? "");
//     // Set dynamic expenses section
//     const expenses = latestOne?.morePay || []; // This should match your `getExpenseArray` output structure
//     expenses.forEach((item, index) => {
//       handleChange(`selectAmount_${index}`, item?.type ?? "");
//       handleChange(`amount_${index}`, item?.amount ?? "");
//       handleChange(`expenseComment_${index}`, item?.comments ?? "");
//     });
//     setExpenseSections(expenses.map(() => ({ id: uuidv4() })));
//   };
//   useEffect(() => {
//     const latestOne = currentPayrollEditing?.otherPayments;
//     if (!latestOne) return;
//     updateFormData(latestOne);
//   }, [latestOne]); // Empty dependency array means this runs once on
//   console.log("rowData", rowData);
//   useEffect(() => {
//     const ids = rowData?.otherPays?.ids;
//     console.log("ids", ids);
//     if (ids?.length) {
//       const lastId = ids[ids.length - 1];
//       console.log("lastId", lastId);
//       handleFetchAPICall(lastId);
//     }
//   }, [rowData?.otherPays?.ids]);

//   useEffect(() => {
//     const INR = Number(formData?.otherAmount);
//     const exchange = Number(formData?.exchangeRate);
//     if (!isNaN(INR) && INR > 0 && !isNaN(exchange) && exchange > 0) {
//       const total = calculateAmountInForeignCurrency(INR,exchange);
//       handleChange("totalAmount", total);
//     } else {
//       handleChange("totalAmount", "");
//     }
//   }, [formData?.otherAmount, formData?.exchangeRate]);
// useEffect(() => {
//   if(formData.totalAmount&&formData.payrollAmount){
//   const total = Number(formData.totalAmount);
//   const payroll = Number(formData.payrollAmount);

//   if (!isNaN(total) && !isNaN(payroll) && payroll === total) {
//     showToast("Payroll Amount cannot be equal to Total Amount");
//     handleChange("payrollAmount", "");
//   }
// }
// }, [formData.totalAmount, formData.payrollAmount]);

//   return (
//     <div className="p-4">
//       <div className="grid grid-cols-3 max-w-6xl gap-x-10 gap-y-6 mt-4 mb-5">
//         <FormFieldSet
//           type="expensesTypes"
//           title="Type of Amount"
//           placeholder="Others"
//           value={formData.typeofAmount}
//           onChange={(value) => handleChange("typeofAmount", value)}
//           error={errors.typeofAmount}
//           disabled={true}
//         />
//         <FormFieldSet
//           type="text"
//           title="Other Amount"
//           // placeholder="Other Amount"
//           placeholder="Enter INR Amount"
//           value={formData.otherAmount}
//           onChange={(value) => handleChange("otherAmount", value)}
//           error={errors.otherAmount}
//         />
//         <FormFieldSet
//           type="datepicker"
//           title="Received Date"
//           placeholder="Received Date"
//           value={formData.receivedDate}
//           onChange={(value) => handleChange("receivedDate", value)}
//           error={errors.receivedDate}
//         />
//         <FormFieldSet
//           type="text"
//           title="Exchange Rate"
//           placeholder="Exchange Rate"
//           value={formData.exchangeRate}
//           onChange={(value) => handleChange("exchangeRate", value)}
//           error={errors.exchangeRate}
//         />
//         <FormFieldSet
//           type="file"
//           title="Attachment"
//           placeholder="Choose File"
//           value={formData.attachment}
//           onChange={(value) => handleChange("attachment", value)}
//           error={errors.attachment}
//         />

//         <FormFieldSet
//           type="text"
//           title="Total Amount"
//           placeholder="Total Amount"
//           value={formData.totalAmount}
//           onChange={(value) => handleChange("totalAmount", value)}
//           error={errors.totalAmount}
//           disabled={true}
//         />
//         <FormFieldSet
//           type="text"
//           title="Payroll Amount"
//           placeholder="Payroll Amount"
//           value={formData.payrollAmount}
//           onChange={(value) => handleChange("payrollAmount", value)}
//           error={errors.payrollAmount}
//         />
//         <FormFieldSet
//           type="text"
//           title="Employer’s Charges"
//           placeholder="Employer’s Charges"
//           value={formData.employersCharges}
//           onChange={(value) => handleChange("employersCharges", value)}
//           error={errors.employersCharges}
//         />
//         <FormFieldSet
//           type="textArea"
//           title="Comments"
//           placeholder="Comments"
//           value={formData.comments}
//           onChange={(value) => handleChange("comments", value)}
//           error={errors.comments}
//         />
//       </div>

//       <div className="flex justify-end mb-4">
//         <Button
//           title={"Add More"}
//           onClick={handleAddClick}
//           icon={"ADD"}
//           color={"info"}
//           variant="text"
//           disabled={expenseSections.length >= 5}
//         />
//       </div>
//       <div className="max-h-[400px] overflow-y-auto pr-2">
//         {expenseSections.map((section, index) => {
//           const selectKey = `selectAmount_${index}`;
//           const amountKey = `amount_${index}`;
//           const commentKey = `expenseComment_${index}`;
//           const hasSelectedAmount =
//             formData[selectKey] && formData[selectKey] !== "";

//           return (
//             <div key={section.id} className="min-h-[240px]">
//               <Divider className="my-2" />
//               <div className="flex justify-between items-start">
//                 <div className="grid grid-cols-2 min-w-5xl gap-x-8 gap-y-8">
//                   <div className="col-span-1 min-w-80 ">
//                     <FormFieldSet
//                       type="expensesTypes"
//                       title="Select Type of Amount"
//                       placeholder="Select Amount"
//                       value={formData[selectKey]}
//                       onChange={(value) => handleChange(selectKey, value)}
//                       error={errors[selectKey]}
//                       // options={ExpensesAmountoptions}
//                       showButton
//                       showSearch
//                     />
//                   </div>

//                   {hasSelectedAmount && (
//                     <>
//                       <div className="col-span-1">
//                         <FormFieldSet
//                           type="text"
//                           title="Enter Amount"
//                           placeholder="$"
//                           value={formData[amountKey]}
//                           onChange={(value) => handleChange(amountKey, value)}
//                           error={errors[amountKey]}
//                         />
//                       </div>
//                       <div className="col-span-2">
//                         <FormFieldSet
//                           type="textArea"
//                           title="Comments"
//                           placeholder="Enter Comments"
//                           value={formData[commentKey]}
//                           onChange={(value) => handleChange(commentKey, value)}
//                           error={errors[commentKey]}
//                         />
//                       </div>
//                     </>
//                   )}
//                 </div>
//                 <div className="flex justify-end items-start">
//                   <Button
//                     type="icon"
//                     variant="text"
//                     color="black"
//                     icon="delete"
//                     onClick={() => handleRemoveClick(index)}
//                   />
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//       <div className="flex justify-end mb-4">
//         <Button
//           title={"Submit"}
//           onClick={() => handleSubmit()}
//           // icon={"ADD"}
//           color={"info"}
//           // variant="text"
//         />
//       </div>
//     </div>
//   );
// };

// export default OtherPayment;

import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  NewTableAdv,
  showToast,
  StatusTags,
  useFormHandler,
} from "../../../../../../../../components";
import { ExpensesAmountoptions } from "../../../../../../../../assets/data/projectData";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllEmpOtherPayments,
  setCurrentPayrollEditing,
  updateOtherPaymentsStart,
} from "../../../../../../../../redux/slices/payroll/payrollSlice";
import { filterEmptyValues } from "../../../../../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../../../../../redux/slices/universal/fileUploadSlice";
import { useLoginUser } from "../../../../../../../../hooks/useLoginUser";
import common from "../../../../../../../../utils/common";
import axiosRequest from "../../../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../../../redux/apiConfig";
import {
  dateFormator,
  getEmployeeId,
  mapTableRows,
} from "../../../../../../../../utils";
import {
  formatCurrency,
  formatWords,
} from "../../../../../../../../utils/stringUtils";
import { usePagination } from "../../../../../../../../hooks";
const OtherPayment = ({ rowData, disableEditing }) => {
  // console.log("rowData", rowData);
  const { getExpenseArray, calculateAmountInForeignCurrency } = common;
  const dispatch = useDispatch();
  const { currentPayrollEditing, empDeduction, empOtherPayments } = useSelector(
    (state) => state.payRoll
  );
  useEffect(() => {
    dispatch(
      setCurrentPayrollEditing({
        tabswitched: true,
      })
    );
  }, []);
  const { userData: loginUserData } = useLoginUser();
  // const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const employeeId = currentPayrollEditing?.employeeId?.uiid;
  const [expenseSections, setExpenseSections] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const otherPayments = empOtherPayments?.data || [];
  const latestOne = otherPayments[otherPayments.length - 1];
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      typeofAmount: "",
      otherAmount: "",
      receivedDate: "",
      exchangeRate: "",
      attachment: [],
      totalAmount: "",
      payrollAmount: "",
      employersCharges: "",
      comments: "",
    },
    {
      // otherAmount: { type: "text", number: true, required: true },
      // exchangeRate: { type: "text", number: true, required: true },
      // attachment: { type: "file" },
      // totalAmount: { type: "text", number: true, required: true },
      // payrollAmount: { type: "text", number: true, required: true },
      // employersCharges: { type: "text", number: true, required: true },
    }
  );
  const { employeeProfileUiid } = useSelector((state) => state?.employee);
  const [bonuses, setBonuses] = useState([]);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    100,
    (newPage, newLimit) => {}
  );
  // const columns = [
  //   // {
  //   //   key: "employeeId",
  //   //   label: "Employee ID",
  //   //   render: (row) => <span className="text-linkblue">{row.employeeId}</span>,
  //   // },
  //   {
  //     key: "referredId",
  //     label: "Referred ID",
  //     render: (row) => (
  //       <span>
  //         {formatWords2(row.referredId?.firstName || "-") +
  //           " " +
  //           formatWords2(row.referredId?.lastName || "-") +
  //           getEmployeeId(
  //             row?.referredId?.uiid,
  //             row?.referredId?.employmentType
  //           )}
  //       </span>
  //     ),

  //     // render: (row) => <span>{row.referredId}</span>,
  //   },
  //   {
  //     key: "jobId",
  //     label: "Job Code",
  //     // render: (row) => <span>{row.jobId}</span>,
  //     render: (row) => <span>{row?.jobId?.jobInfo?.jobCode}</span>,
  //   },
  //   // {
  //   //   key: "period",
  //   //   label: "Period",
  //   //   render: (row) => (
  //   //     <span>
  //   //       {dateFormator(row.period.from, "month-day-year")} -{" "}
  //   //       {dateFormator(row.period.to, "month-day-year")}
  //   //     </span>
  //   //   ),
  //   // },
  //   {
  //     key: "bonusAmt",
  //     label: "Bonus Amount",
  //     render: (row) => <span>{formatCurrency(row.bonusAmt)}</span>,
  //   },
  //   {
  //     key: "status",
  //     label: "Status",
  //     render: (row) => (
  //       <StatusTags
  //         tag={formatWords(
  //           "",
  //           row.status === 1
  //             ? "Unpaid"
  //             : row.status === 2
  //             ? "In Progress"
  //             : row.status === 3
  //             ? "Paid"
  //             : "Skipped"
  //         )}
  //       />
  //     ),
  //   },
  //   // {
  //   //   key: "linkedPayroll",
  //   //   label: "Linked Payroll",
  //   //   render: (row) => <span>{row.linkedPayroll || "-"}</span>,
  //   // },
  //   // {
  //   //   key: "paidOn",
  //   //   label: "Paid On",
  //   //   render: (row) =>
  //   //     row.paidOn ? dateFormator(row.paidOn, "month-day-year") : "-",
  //   // },
  //   // {
  //   //   key: "addedBy",
  //   //   label: "Added By",
  //   //   render: (row) => <span>{row.addedBy}</span>,
  //   // },
  // ];
  const columns = [
    {
      key: "referredId",
      label: "Candidate Name",
      render: (row) => (
        <span>{`${
          [row.referredId?.firstName, row.referredId?.lastName]
            .filter(Boolean)
            .join(" ") || "-"
        } (${getEmployeeId(
          row?.referredId?.uiid,
          row?.referredId?.employmentType
        )})`}</span>
      ),
    },
    {
      key: "jobId",
      // label: "Job ID",
      label: "Job Code",
      render: (row) => <span>{row?.jobId?.jobInfo?.jobCode}</span>,
    },
    {
      key: "jobId1",
      // label: "Job ID",
      label: "Project",
      render: (row) => <span>{row?.jobId?.jobInfo?.jobTitle}</span>,
    },
    {
      key: "period",
      label: "Period",
      render: (row) => (
        <span>
          {dateFormator(row.period.from, "month-day-year")} -{" "}
          {dateFormator(row.period.to, "month-day-year")}
        </span>
      ),
    },
    {
      key: "bonusAmt",
      label: "Bonus Amount",
      render: (row) => <span>{formatCurrency(row.bonusAmt)}</span>,
    },

    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusTags
          tag={formatWords(
            "",
            row?.status === 1
              ? "Unpaid"
              : row?.status === 2
              ? "In Progress"
              : row?.status === 3
              ? "Paid"
              : "Skipped"
          )}
        />
      ),
    },

    {
      key: "bonusAmt1",
      label: "Total Balance",
      render: (row) => <span>{formatCurrency(row.balanceAmt)}</span>,
    },
    //     {
    //   key: "paidOn",
    //   label: "Paid On",
    //   render: (row) =>
    //     row.paidOn ? dateFormator(row.paidOn, "month-day-year") : "-",
    // },
    // {
    //   key: "linkedPayroll",
    //   label: "Linked Payroll",
    //   render: (row) => <span>{row?.usage?.payrollId ? "Linked With Payroll" :"-" || "-"}</span>,
    // },

    // {
    //   key: "addedBy",
    //   label: "Added By",
    //   render: (row) => <span>{row.addedBy}</span>,
    // },
  ];
  useEffect(() => {
    const fetchBonuses = async () => {
      let employeeIdToCall =
        rowData?.employeeId?.employmentType === 4
          ? rowData?.employeeId?.linkedTo
          : rowData?.employeeId?.uiid;
      let filter = {
        // employeeId: { type: "NONE", value: employeeId },
        employeeId: { type: "NONE", value: employeeIdToCall },
        status: { type: "IN", value: [1, 2] },
      };
      const response = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.EMPLOYEE_BONUS.GET_ALL,
        params: {
          coll: "EmpBonusPay",
          ref: "ReferredId Placement",
          incl: ["firstName lastName employmentType uiid", "jobInfo"],
          fil: JSON.stringify(filter),
          lim: limit,
          pg: page,
        },
      });
      setBonuses(response?.data?.data || []);
      const total = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.EMPLOYEE_BONUS.GET_TOTAL_COUNT,
        params: {
          coll: "EmpBonusPay",
          fil: JSON.stringify(filter),
          // lim: limit,
          // pg: page,
        },
      });
      // console.log("total for bonus", total?.data?.data || 10);
      setTotalCount(total?.data?.data || 0);
    };
    if (employeeProfileUiid) {
      fetchBonuses();
    }
  }, [limit, page]);
  const alteredColumns =
    bonuses.length > 0
      ? bonuses?.map((row) => {
          return { id: row.uiid, ...row };
        })
      : [];
  // console.log("alteredColumns", alteredColumns);
  const mappedRows = mapTableRows(alteredColumns, columns);

  const handleAddClick = () => {
    if (expenseSections.length < 5) {
      setExpenseSections([...expenseSections, { id: uuidv4() }]);
    }
  };

  const handleRemoveClick = (index, section) => {
    console.log({ index, section, expenseSections });
    // const updated = [...expenseSections];
    // updated.splice(index, 1);
    handleChange(`selectAmount_${index}`, "");
    handleChange(`amount_${index}`, "");
    handleChange(`expenseComment_${index}`, "");
    // setExpenseSections(updated);
  };
  const handleFinalDispatch = (submissionData) => {
    const payrollAmount = Number(submissionData?.payrollAmt || 0);
    const additionalPayments = Array.isArray(submissionData?.morePay)
      ? submissionData.morePay.reduce(
          (sum, item) => sum + Number(item?.amount || 0),
          0
        )
      : 0;
    // console.log("payrollAmount", payrollAmount);
    // console.log("additionalPayments", additionalPayments);
    dispatch(
      setCurrentPayrollEditing({
        otherPays: { ...submissionData },
        finalOtherTotalAmount: payrollAmount + additionalPayments,
      })
    );
    showToast("payroll added successfully", "success");
  };
  const handleSubmit = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const total = Number(formData.totalAmount);
      const payroll = Number(formData.payrollAmount);
      // if (payroll === total) {
      //   showToast("Payroll Amount cannot be equal to Total Amount");
      //   return;
      // }
      const morePay = getExpenseArray(expenseSections, formData);
      const otherPayDetails = {
        inrAmt: formData?.otherAmount,
        receivedDate: formData?.receivedDate,
        exchangeRate: formData?.exchangeRate,
        totalAmt: formData?.totalAmount,
        payrollAmt: formData?.payrollAmount,
        employersCharge: formData?.employersCharges,
        comments: formData?.comments,
        morePay: morePay,
      };
      // this line is bug
      // const cleanedData = filterEmptyValues(otherPayDetails);
      const cleanedData = otherPayDetails;
      const cleanAttachments =
        Array.isArray(formData.attachment) && formData.attachment.length > 0
          ? formData.attachment
          : [];
      if (cleanAttachments.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: employeeId,
            entity: "empotherpays",
            category: "empotherpays",
            coll: "EmpOtherPay",
            doc: cleanAttachments,
            onSuccess: (fileData) => {
              const attachmentKeys = fileData
                .filter((data) => data.key)
                .map((data) => data.key);
              const updatedSubmissionData = {
                ...cleanedData,
                attachments: attachmentKeys,
              };
              handleFinalDispatch(updatedSubmissionData);
            },
          })
        );
      } else {
        handleFinalDispatch(cleanedData);
      }
    } else {
      showToast("Please fill all the required fields before proceeding");
    }
  };

  // const handleFetchAPICall = async (uiid) => {
  //   try {
  //     const filter = {
  //       uiid: {
  //         type: "NONE",
  //         value: uiid,
  //       },
  //     };
  //     const response = await axiosRequest({
  //       method: "GET",
  //       url: ENDPOINTS.EMPLOYEE_OTHER_PAYMENTS.GET_BY_UIID,
  //       params: {
  //         coll: "EmpOtherPay",
  //         fil: JSON.stringify(filter),
  //       },
  //     });
  //     const data = response?.data?.data || {};
  //     if (response.success) {
  //       // dispatch(setCurrentPayrollEditing({ otherPayments: data }));
  //       const oldpayroll =
  //         currentPayrollEditing?.otherPayments?.amounts?.payroll || 0;
  //       const oldmoreTotal =
  //         currentPayrollEditing?.otherPayments?.morePay?.reduce(
  //           (acc, item) => acc + (item.amount || 0),
  //           0
  //         ) || 0;
  //       const baseAmount =
  //         (currentPayrollEditing?.totalAmount || 0) - oldpayroll - oldmoreTotal;
  //       const payroll = data?.amounts?.payroll || 0;
  //       const moreTotal =
  //         data?.morePay?.reduce((acc, item) => acc + (item.amount || 0), 0) ||
  //         0;
  //       dispatch(
  //         setCurrentPayrollEditing({
  //           otherPayments: data,
  //           finalOtherTotalAmount: payroll + moreTotal,
  //         })
  //       );
  //       updateFormData(data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching API:", error);
  //   }
  // };

  const updateFormData = (latestOne) => {
    if (!latestOne) return; // Early return if `latestOne` is undefined or null
    console.log({latestOne})
    // Use conditional checks to only update if the data exists (not undefined or null)
    if (latestOne?.totalAmt)
      handleChange("totalAmount", `${latestOne?.totalAmt}`);
    if (latestOne?.payrollAmt)
      handleChange("payrollAmount", `${latestOne?.payrollAmt}`);
    if (latestOne?.inrAmt) handleChange("otherAmount", `${latestOne?.inrAmt}`);
    if (latestOne?.receivedDate)
      handleChange("receivedDate", latestOne?.receivedDate);
    if (latestOne?.exchangeRate)
      handleChange("exchangeRate", `${latestOne?.exchangeRate}`);
    if (latestOne?.employersCharge)
      handleChange("employersCharges", `${latestOne?.employersCharge}`);
    if (latestOne?.comments) handleChange("comments", `${latestOne?.comments}`);

    // Set dynamic expenses section
    const expenses = latestOne?.morePay || []; // Default to empty array if no expenses
    expenses.forEach((item, index) => {
      if (item?.type) handleChange(`selectAmount_${index}`, item?.type);
      if (item?.amount) handleChange(`amount_${index}`, item?.amount);
      if (item?.comments)
        handleChange(`expenseComment_${index}`, item?.comments);
    });

    // Set expense sections if there are any expenses
    if (expenses.length > 0) {
      setExpenseSections(expenses.map(() => ({ id: uuidv4() })));
    }
  };

  useEffect(() => {
    const latestOne = currentPayrollEditing?.otherPays;
    if (!latestOne) return; // If no data, exit early
    updateFormData(latestOne); // Update the form data with the new latestOne
  }, [currentPayrollEditing?.otherPays]); // Dependency on currentPayrollEditing?.otherPays

  useEffect(() => {
    const ids = rowData?.otherPays?.ids;
    if (ids?.length) {
      const lastId = ids[ids.length - 1];
      // console.log("lastId", lastId);
      // handleFetchAPICall(lastId);
    }
  }, [rowData?.otherPays?.ids]);

  useEffect(() => {
    if (formData?.otherAmount && formData?.exchangeRate) {
      const INR = Number(formData?.otherAmount);
      const exchange = Number(formData?.exchangeRate);
      if (!isNaN(INR) && INR > 0 && !isNaN(exchange) && exchange > 0) {
        const total = calculateAmountInForeignCurrency(INR, exchange);
        handleChange("totalAmount", total);
      } else {
        handleChange("totalAmount", "");
      }
    }
  }, [formData?.otherAmount, formData?.exchangeRate]);
  useEffect(() => {
    if (formData.totalAmount && formData.payrollAmount) {
      const total = Number(formData.totalAmount);
      const payroll = Number(formData.payrollAmount);

      if (!isNaN(total) && !isNaN(payroll) && payroll === total) {
        showToast("Payroll amount cannot be equal to the total amount");
        handleChange("payrollAmount", "");
        handleChange("employersCharges", "");
      } else {
        const empChar = (total - payroll).toFixed(2);
        handleChange("employersCharges", `${empChar}`);
      }
    }
  }, [formData.totalAmount, formData.payrollAmount]);

  const alteredColumnsRef = useRef(alteredColumns);
  const prevTotalBonusesRef = useRef(0);

  useEffect(() => {
    alteredColumnsRef.current = alteredColumns;
  }, [alteredColumns]);

  const [bonusIds, setBonusIds] = useState([]);

  function handleSelectionChange(ids) {
    setBonusIds(ids);
    const latestAltered = alteredColumnsRef.current;
    let totalBonuses = latestAltered
      ?.filter((item) => ids.includes(item?.id))
      .reduce((acc, item) => acc + (item?.bonusAmt || 0), 0);
    const currentCheckBoxChanges = {
      bonusIds: ids,
      totalBonuses,
      bonusSectionViewed: true,
    };
    dispatch(setCurrentPayrollEditing(currentCheckBoxChanges));
  }

  useEffect(() => {
    let totalBonuses = alteredColumns
      ?.filter((item) => bonusIds.includes(item?.id))
      .reduce((acc, item) => acc + (item?.bonusAmt || 0), 0);

    if (prevTotalBonusesRef.current !== totalBonuses) {
      prevTotalBonusesRef.current = totalBonuses;
      const currentCheckBoxChanges = {
        totalBonuses,
      };
      dispatch(setCurrentPayrollEditing(currentCheckBoxChanges));
    }
  }, [bonusIds, alteredColumns]);

  return (
    <div className="p-4">
      <div className="grid grid-cols-2 lg:grid-cols-3 max-w-6xl gap-x-10 gap-y-6 mt-4 mb-5">
        <FormFieldSet
          type="expensesTypes"
          title="Type of Amount"
          placeholder="Others"
          value={formData.typeofAmount}
          onChange={(value) => handleChange("typeofAmount", value)}
          error={errors.typeofAmount}
          disabled={true}
        />
        <FormFieldSet
          type="text"
          title="Other Amount"
          // placeholder="Other Amount"
          placeholder="Enter INR Amount"
          value={formData.otherAmount}
          onChange={(value) => {
            handleChange("otherAmount", value)
            if(!value){
            handleChange("typeofAmount", "")
            handleChange("receivedDate", "")
            handleChange("exchangeRate", "")
            handleChange("attachment", [])
            handleChange("totalAmount", "")
            handleChange("payrollAmount", "")
            handleChange("employersCharges", "")
            handleChange("comments", "")
            }
          }}
          error={errors.otherAmount}
          disabled={disableEditing}
        />
        {console.log({"formData.receivedDate":formData.receivedDate})}
        <FormFieldSet
          type="datepicker"
          title="Received Date"
          placeholder="Received Date"
          value={formData.receivedDate}
          onChange={(value) => handleChange("receivedDate", value)}
          error={errors.receivedDate}
          disabled={disableEditing}
          showDropdown={false}
        />
        <FormFieldSet
          type="text"
          title="Exchange Rate"
          placeholder="Exchange Rate"
          value={formData.exchangeRate}
          onChange={(value) => handleChange("exchangeRate", value)}
          error={errors.exchangeRate}
          disabled={disableEditing}
        />
        <FormFieldSet
          type="file"
          title="Attachment"
          placeholder="Choose File"
          value={formData.attachment}
          onChange={(value) => handleChange("attachment", value)}
          error={errors.attachment}
          disabled={disableEditing}
        />

        <FormFieldSet
          type="text"
          title="Total Amount"
          placeholder="Total Amount"
          value={formData.totalAmount}
          onChange={(value) => handleChange("totalAmount", value)}
          error={errors.totalAmount}
          disabled={true}
        />
        <FormFieldSet
          type="text"
          title="Payroll Amount"
          placeholder="Payroll Amount"
          value={formData.payrollAmount}
          onChange={(value) => handleChange("payrollAmount", value)}
          error={errors.payrollAmount}
          disabled={disableEditing}
        />
        <FormFieldSet
          type="text"
          title="Employer’s Charges"
          placeholder="Employer’s Charges"
          value={formData.employersCharges}
          onChange={(value) => handleChange("employersCharges", value)}
          error={errors.employersCharges}
          disabled={disableEditing}
        />
        <FormFieldSet
          type="textArea"
          title="Comments"
          placeholder="Comments"
          value={formData.comments}
          onChange={(value) => handleChange("comments", value)}
          error={errors.comments}
          disabled={disableEditing}
        />
      </div>
      {/* <div className="flex justify-end mb-4 ">
        <Button
          title={"Submit"}
          onClick={() => handleSubmit()}
          // icon={"ADD"}
          color={"primary"}
          className="w-[130px]"
          // variant="text"
        />
      </div> */}
      <div className="flex justify-end mb-4">
        <Button
          title={"Add More"}
          onClick={handleAddClick}
          icon={"ADD"}
          // size="sm"
          className="w-[130px]"
          color={"primary"}
          variant="outlined"
          disabled={expenseSections.length >= 5 || disableEditing}
        />
      </div>
      <div className="max-h-[400px] overflow-y-auto pr-2">
        {console.log({ expenseSections, formData })}
        {expenseSections.map((section, index) => {
          const selectKey = `selectAmount_${index}`;

          const amountKey = `amount_${index}`;
          const commentKey = `expenseComment_${index}`;
          const hasSelectedAmount =
            formData[selectKey] && formData[selectKey] !== "";

          return (
            <div key={section.id} className="min-h-[240px]">
              <Divider className="my-2" />
              <div className="flex justify-between items-start">
                <div className="grid grid-cols-2 min-w-5xl gap-x-8 gap-y-8">
                  <div className="col-span-1 min-w-80 ">
                    <FormFieldSet
                      type="expensesTypes"
                      title="Select Type of Amount"
                      placeholder="Select Amount"
                      value={formData[selectKey]}
                      onChange={(value) => handleChange(selectKey, value)}
                      error={errors[selectKey]}
                      // options={ExpensesAmountoptions}
                      showButton
                      showSearch
                    />
                  </div>

                  {hasSelectedAmount && (
                    <>
                      <div className="col-span-1">
                        <FormFieldSet
                          type="text"
                          title="Enter Amount"
                          placeholder="$"
                          value={formData[amountKey]}
                          onChange={(value) => handleChange(amountKey, value)}
                          error={errors[amountKey]}
                          disabled={disableEditing}
                        />
                      </div>
                      <div className="col-span-2">
                        <FormFieldSet
                          type="textArea"
                          title="Comments"
                          placeholder="Enter Comments"
                          value={formData[commentKey]}
                          onChange={(value) => handleChange(commentKey, value)}
                          error={errors[commentKey]}
                          disabled={disableEditing}
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className="flex justify-end items-start">
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    icon="delete"
                    onClick={() => handleRemoveClick(index, section)}
                    disabled={disableEditing}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex justify-end mb-4 ">
        <Button
          title={"Submit"}
          onClick={() => handleSubmit()}
          // icon={"ADD"}
          color={"primary"}
          className="w-[130px]"
          disabled={disableEditing}
          // variant="text"
        />
      </div>
      {/* <div className="flex justify-end mb-4 ">
        <Button
          title={"Submit"}
          onClick={() => handleSubmit()}
          // icon={"ADD"}
          color={"primary"}
          className="w-[130px]"
          // variant="text"
        />
      </div> */}
      <div className="p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
        <div className="font-semibold">Bonus Payments</div>
        <div>
          <NewTableAdv
            columns={columns}
            rows={mappedRows}
            showCheckbox
            onSelectionChange={(ids) => handleSelectionChange(ids)}
            defaultSelectedRows={
              currentPayrollEditing?.bonusSectionViewed
                ? currentPayrollEditing?.bonusIds
                : rowData?.bonuses?.ids
            }
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            onPageChange={setPage}
            onLimitChange={handleLimitChange}
            hideToolBar={true}
          />
        </div>
      </div>
    </div>
  );
};

export default OtherPayment;
